module.exports = __webpack_public_path__ + "static/australia-products-9314a3dec159f7b4bc065f6f8b484274.jpg";